module.exports = __webpack_public_path__ + "img/detail-marked.f014bc3c.svg";